import { render } from "./BookingDetailsBanner.vue?vue&type=template&id=7ad0e8f6"
import script from "./BookingDetailsBanner.vue?vue&type=script&lang=js"
export * from "./BookingDetailsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__